"use client";

import React from "react";
import { Clapperboard, CircleUser, GraduationCap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const features = [{
  icon: Clapperboard,
  title: "Natural Mineral Therapies",
  description: "Harness the restorative power of therapeutic mud and mineral water pools in a serene environment designed for deep spinal healing and recovery.",
  link: "#"
}, {
  icon: CircleUser,
  title: "Advanced Medical Care",
  description: "Our clinic provides a specialized recovery phase with expert medical oversight and tailored physical therapy protocols for Irish surgery patients.",
  link: "#"
}, {
  icon: GraduationCap,
  title: "Holistic Wellness Path",
  description: "Enjoy a luxury rehabilitation journey that bridges the gap between surgery and home, set within Lithuania's serene forest landscapes.",
  link: "#"
}];
export default function Intro() {
  return;
}